/**
 * This file was auto-generated by openapi-typescript.
 * Do not make direct changes to the file.
 */

export interface paths {
    "/openfeign/odds/v2/recommend": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        post: operations["commonBatchGetRecommend"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/openfeign/odds/v2/outrightMarketCount": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * 根据outrightId列表获取盘口数量
         * @description 根据outrightId列表获取盘口数量
         */
        post: operations["outrightMarketCount"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/openfeign/odds/v2/getOutcomesForCodes": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        post: operations["getOutcomesForCodes"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/openfeign/odds/v2/getMarketsForMatches": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        post: operations["getMarketsForMatches"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/openfeign/odds/v2/getMarketsForMatchesByTab": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        post: operations["getMarketsForMatchesByTab"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/openfeign/odds/v2/checkMarketExistence": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        post: operations["checkMarketExistence"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/openfeign/odds/v2/bz/recommend/top": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        post: operations["recommendTop"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/openfeign/odds/v2/bz/recommend/batch": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        post: operations["recommendBatch"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/openapi/odds/v2/snapshot": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * 根据code获取比赛盘口快照
         * @description 根据code获取比赛盘口快照
         */
        post: operations["listSnapshot"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/odds/v2/snapshot": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * 根据code获取比赛盘口快照
         * @description 根据code获取比赛盘口快照
         */
        post: operations["listSnapshot_1"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/odds/v2/listLatestOutcomes": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * 根据 outcomeCode 批量查询投注项最新详情
         * @description 根据 outcomeCode 批量查询投注项最新详情，支持 matchIdType
         */
        post: operations["listLatestOutcomes"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/openapi/odds/v2/listLatestOutcomes": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * 根据 outcomeCode 批量查询投注项最新详情
         * @description 根据 outcomeCode 批量查询投注项最新详情，支持 matchIdType
         */
        post: operations["listLatestOutcomes_1"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/odds/v2/list/recommend": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * 根据比赛id获取推荐玩法赔率数据
         * @description 获取基本赔率，每个玩法仅推荐一条推荐盘口
         */
        post: operations["listRecommendOdds"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/openapi/odds/v2/list/recommend": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * 根据比赛id获取推荐玩法赔率数据
         * @description 获取基本赔率，每个玩法仅推荐一条推荐盘口
         */
        post: operations["listRecommendOdds_1"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/openapi/odds/v2/list/bookmaker": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * 根据比赛id获取赔率数据按博彩公司分组
         * @description 获取的是所有的博彩公司的赔率数据
         */
        post: operations["listBookmakerOdds"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/odds/v2/list/bookmaker": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * 根据比赛id获取赔率数据按博彩公司分组
         * @description 获取的是所有的博彩公司的赔率数据
         */
        post: operations["listBookmakerOdds_1"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/openapi/odds/v2/batchHistoryByMarketCode": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * 根据盘口marketCode/oddsCode批量获取历史赔率
         * @description 根据盘口marketCode和oddsCode返回最新快照
         */
        post: operations["listOddsHistoryBatch"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/odds/v2/batchHistoryByMarketCode": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * 根据盘口marketCode/oddsCode批量获取历史赔率
         * @description 根据盘口marketCode和oddsCode返回最新快照
         */
        post: operations["listOddsHistoryBatch_1"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/odds/v2/bz/custombet/calculate": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * 计算赔率
         * @description 计算赔率
         */
        post: operations["cbCalculate"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/odds/v2/bz/custombet/calculateFilter": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * 计算赔率并且返回所有盘口是否冲突
         * @description 计算赔率并且返回所有盘口是否冲突
         */
        post: operations["cbCalculateFilter"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/odds/v2/bz/test": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get: operations["setstesf22"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/odds/v2/bz/outright/detail": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * 根据outrightId列表获取盘口详情
         * @description 根据outrightId列表获取盘口详情
         */
        get: operations["outrightMarketDetail"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/odds/v2/bz/other/balance": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * 获取其他平衡盘口数据
         * @description 获取其他平衡盘口数据
         */
        get: operations["listBenchmarkOtherBalance"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/odds/v2/bz/format": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * 获取默认展示的赔率格式
         * @description 获取默认展示的赔率格式
         */
        get: operations["getOddsFormat"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/odds/v2/bz/custombet": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * 根据比赛id和运动类型获取custombet数据
         * @description 根据比赛id和运动类型获取custombet数据
         */
        get: operations["listCustomBetMarkets"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/odds/v2/bz/all": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * 根据比赛id和运动类型获取赔率数据
         * @description 根据比赛id和运动类型获取赔率数据
         */
        get: operations["listBenchmarkAll"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/odds/testfunc": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** @deprecated */
        get: operations["testfunc"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/odds/testfunc2": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** @deprecated */
        get: operations["testfunc2"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/odds/outcomeDefToTitleCase": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** @deprecated */
        get: operations["outcomeDefToTitleCase"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/odds/v2/bz/recommend/batch": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        post: operations["createBzRecommendBatch1"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/odds/v2/bz/outright/top": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * 获取top outright
         * @description 获取top outright
         */
        get: operations["getBzOutrightTop"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/odds/v2/bz/system/offered": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * 获取SystemOffered配置
         * @description 获取SystemOffered配置
         */
        get: operations["getOddsBzOffered"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/odds/v2/bz/setting": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * 获取odds设置
         * @description 获取odds设置
         */
        get: operations["getOddsBzSetting"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
}
export type webhooks = Record<string, never>;
export interface components {
    schemas: {
        BatchQueryOddsLeagueRequest: {
            matchIdMap: {
                [key: string]: number;
            };
            /** Format: int32 */
            matchIdType: number;
            /** Format: int32 */
            sportType: number;
            marketStrs?: string[];
        };
        SfOutcomeDetailResult: {
            uniqueCode: string;
            marketId: string;
            specifiers: string;
            /** Format: int32 */
            status: number;
            outcomeId: string;
            /** Format: int64 */
            bookmakerId: number;
            /** Format: int64 */
            matchId: number;
            /** Format: int32 */
            phase: number;
            odds: number;
            preOdds: number;
            baseOdds: number;
            /** Format: int32 */
            active: number;
            /** Format: int64 */
            createTime: number;
            /** Format: int64 */
            updateTime: number;
        };
        SingleResponseMapLongListSfOutcomeDetailResult: {
            success: boolean;
            errCode: string;
            errMessage: string;
            data: {
                [key: string]: components["schemas"]["SfOutcomeDetailResult"][];
            };
        };
        SingleResponseMapStringInteger: {
            success: boolean;
            errCode: string;
            errMessage: string;
            data: {
                [key: string]: number;
            };
        };
        OutcomeBatchParam: {
            matchId: string;
            outcomeCodeList: string[];
        };
        MultiResponseOutcomeDetailResult: {
            success: boolean;
            errCode: string;
            errMessage: string;
            data: components["schemas"]["OutcomeDetailResult"][];
        };
        OutcomeDetailResult: {
            siteMatchId: string;
            uniqueCode: string;
            marketId: string;
            specifiers: string;
            specifiersMap: {
                [key: string]: string;
            };
            originalSpecifiers: string;
            originalSpecifiersMap: {
                [key: string]: string;
            };
            producerId: string;
            marketName: string;
            outcomeName: string;
            /** Format: int32 */
            status: number;
            outcomeId: string;
            /** Format: int64 */
            bookmakerId: number;
            /** Format: int64 */
            matchId: number;
            /** Format: int32 */
            phase: number;
            odds: number;
            /** Format: int32 */
            active: number;
            /** Format: int64 */
            createTime: number;
            /** Format: int64 */
            updateTime: number;
        };
        MarketBatchParam: {
            matchIds: string[];
        };
        MatchMarketResult: {
            siteMatchId: string;
            /** Format: int64 */
            fotmobMatchId: number;
            /** Format: int64 */
            fotmobSportType: number;
            /** Format: int64 */
            bookmakerId: number;
            marketId: string;
            specifiers: string;
            specifiersMap: {
                [key: string]: string;
            };
            originalSpecifiers: string;
            originalSpecifiersMap: {
                [key: string]: string;
            };
            producerId: string;
            /** Format: int32 */
            status: number;
            /** Format: int32 */
            phase: number;
            /** Format: int64 */
            createTime: number;
            /** Format: int64 */
            updateTime: number;
            outcomes: components["schemas"]["OutcomeResult"][];
        };
        MultiResponseMatchMarketResult: {
            success: boolean;
            errCode: string;
            errMessage: string;
            data: components["schemas"]["MatchMarketResult"][];
        };
        OutcomeResult: {
            uniqueCode: string;
            outcomeId: string;
            /** Format: int64 */
            bookmakerId: number;
            /** Format: int32 */
            phase: number;
            odds: number;
            /** Format: int32 */
            active: number;
            /** Format: int64 */
            createTime: number;
            /** Format: int64 */
            updateTime: number;
        };
        MarketBatchParamByTab: {
            matchIds: string[];
            tabId: string;
        };
        MarketExistenceBatchParam: {
            matchIds: string[];
        };
        MarketExistenceResult: {
            matchId: string;
            preMatchExist: boolean;
            liveMatchExist: boolean;
        };
        MultiResponseMarketExistenceResult: {
            success: boolean;
            errCode: string;
            errMessage: string;
            data: components["schemas"]["MarketExistenceResult"][];
        };
        MarketRecommendQueryRequest: {
            matchId: string;
            sportId: string;
            /** Format: int32 */
            phase: number;
        };
        MarketRecommendTopRequest: {
            batch: components["schemas"]["MarketRecommendQueryRequest"][];
        };
        GroupConfigDTO: {
            key: string;
            /** Format: int32 */
            index: number;
            name: string;
        };
        /** 按玩法类型分组的赔率 */
        MarketResponse: {
            /**
             * 盘口ID
             * @description 盘口ID
             */
            marketId: string;
            /**
             * 玩法名称
             * @description 玩法名称
             */
            marketName: string;
            /**
             * 玩法显示名称
             * @description 玩法显示名称
             */
            displayName: string;
            marketTabType: string;
            colNameList: string[];
            /** Format: int32 */
            colSize: number;
            groupConfig: components["schemas"]["GroupConfigDTO"];
            options: components["schemas"]["OptionDTO"][];
            /**
             * 盘口投注项赔率列表
             * @description 盘口投注项赔率列表
             */
            marketSpecifierList: components["schemas"]["MarketSpecifierDTO"][];
        };
        /**
         * 盘口投注项赔率列表
         * @description 盘口投注项赔率列表
         */
        MarketSpecifierDTO: {
            specifiers: string;
            /** Format: int32 */
            status: number;
            outcomes: components["schemas"]["OutcomeDTO"][];
        };
        MatchRecommendTopResponse: {
            matchMarkets: {
                [key: string]: components["schemas"]["MarketResponse"];
            };
        };
        OptionDTO: {
            groupName: string;
            name: string;
            type: string;
            content: Record<string, never>;
        };
        OutcomeDTO: {
            code: string;
            outcomeId: string;
            outcomeName: string;
            displayName: string;
            odds: number;
            /** Format: int32 */
            active: number;
            /** Format: int64 */
            updateTime: number;
            /** Format: int32 */
            phase: number;
            frontIndex: string;
        };
        SingleResponseMatchRecommendTopResponse: {
            success: boolean;
            errCode: string;
            errMessage: string;
            data: components["schemas"]["MatchRecommendTopResponse"];
        };
        MarketRecommendBatchRequest: {
            batch: components["schemas"]["MarketRecommendQueryRequest"][];
            /** Format: int32 */
            marketMode: number;
        };
        MarketBatchResponse: {
            marketList: components["schemas"]["MarketResponse"][];
            /** Format: int32 */
            totalMarkets: number;
            hasOtherBalance: boolean;
        };
        MatchRecommendBatchResponse: {
            matchMarkets: {
                [key: string]: components["schemas"]["MarketBatchResponse"];
            };
        };
        SingleResponseMatchRecommendBatchResponse: {
            success: boolean;
            errCode: string;
            errMessage: string;
            data: components["schemas"]["MatchRecommendBatchResponse"];
        };
        QueryOddsSnapshotRequest: {
            /**
             * 体育类型
             * Format: int32
             * @description 1-足球, 2-篮球, 等
             */
            sportType: number;
            /** 赔率唯一编码列表 */
            codeList: components["schemas"]["UniqueCode"][];
        };
        /** 赔率唯一编码列表 */
        UniqueCode: {
            /**
             * 站点比赛ID
             * Format: int64
             */
            matchId: number;
            /**
             * 赔率唯一编码
             * @description 格式：bookmakerId_phase_hash
             */
            uniqueCode: string;
            /**
             * 更新时间
             * Format: int64
             * @description 可选，用于客户端去重或比对
             */
            updateTime: number;
        };
        BatchOutcomeLatestParam: {
            /** Format: int32 */
            matchIdType: number;
            /** Format: int64 */
            matchId: number;
            uniqueCodeList: string[];
            /** Format: int32 */
            sportType: number;
        };
        BatchQueryOddsRequest: {
            matchIdList: number[];
            /** Format: int32 */
            matchIdType: number;
            /** Format: int32 */
            sportType: number;
        };
        BatchQueryBookmakerOddsRequest: {
            matchIdList: number[];
            /** Format: int32 */
            matchIdType: number;
            bookmakerIdList?: number[];
            /** Format: int32 */
            sportType: number;
        };
        /** 按玩法类型分组的赔率 */
        SfMarketOutcomeResponse: {
            /**
             * bookmakerId
             * Format: int64
             * @description bookmakerId
             */
            bookmakerId: number;
            /**
             * 盘口详情列表
             * @description 盘口详情列表
             */
            outcomeDetailResults: components["schemas"]["SfOutcomeDetailResult"][];
        };
        SingleResponseMapLongListSfMarketOutcomeResponse: {
            success: boolean;
            errCode: string;
            errMessage: string;
            data: {
                [key: string]: components["schemas"]["SfMarketOutcomeResponse"][];
            };
        };
        BatchQueryOddsHistoryRequest: {
            /**
             * 体育类型
             * Format: int32
             * @description 1-足球, 2-篮球, 等
             */
            sportType: number;
            /**
             * 比赛ID
             * Format: int64
             * @description MatchId
             */
            matchId: number;
            bookmakerIdList: number[];
            marketId: string;
            specifier: string;
            /**
             * 投注项ID
             * @description OutcomeId
             */
            outcomeId: string;
            /**
             * 唯一编码
             * @description UniqueCode
             */
            uniqueCode: string;
        };
        BatchOddsHistoryResponse: {
            outcomeDetail: components["schemas"]["OutcomeDetailResult"];
            /** 赔率历史信息 */
            historyList: components["schemas"]["OddsHistory"][];
        };
        MultiResponseBatchOddsHistoryResponse: {
            success: boolean;
            errCode: string;
            errMessage: string;
            data: components["schemas"]["BatchOddsHistoryResponse"][];
        };
        /** 赔率历史信息 */
        OddsHistory: {
            /** 赔率唯一编码 */
            uniqueCode: string;
            /** 赔率值 */
            oddsValue: number;
            /**
             * 更新时间
             * Format: int64
             */
            updateTime: number;
            /**
             * 赔率状态
             * Format: int32
             * @description 1-active, 0-not active
             */
            oddsStatus: number;
            /**
             * 前一个赔率
             * @description 前一个赔率
             */
            preOddsValue: number;
            /**
             * 比赛的分钟数
             * @description 比赛的分钟数
             */
            minute: number;
        };
        CBCalculateRequest: {
            selections: components["schemas"]["CBCalculateSelection"][];
        };
        CBCalculateSelection: {
            matchId: string;
            code: string;
            marketId: string;
            specifiers: string;
            outcomeId: string;
        };
        CBCalculateResponse: {
            totalOdds: number;
        };
        SingleResponseCBCalculateResponse: {
            success: boolean;
            errCode: string;
            errMessage: string;
            data: components["schemas"]["CBCalculateResponse"];
        };
        CBCalculateFilterResponse: {
            totalOdds: number;
            selections: components["schemas"]["CBSelectionResponse"][];
        };
        CBSelectionResponse: {
            matchId: string;
            code: string;
            marketId: string;
            specifiers: string;
            outcomeId: string;
            /** Format: int32 */
            conflict: number;
        };
        SingleResponseCBCalculateFilterResponse: {
            success: boolean;
            errCode: string;
            errMessage: string;
            data: components["schemas"]["CBCalculateFilterResponse"];
        };
        StrategySportTabI18nParams: {
            /**
             * Format: int64
             * @description 主键ID，更新/删除使用
             */
            id: number;
            /** @description 运动ID */
            sportId: string;
            /** @description Tab ID */
            tabId: string;
            /** @description 语言编码 */
            languageCode: string;
            /** @description 国际化名称 */
            name: string;
            /** @description 策略id */
            strategyId: string;
        };
        SingleResponse: {
            success: boolean;
            errCode: string;
            errMessage: string;
            data: Record<string, never>;
        };
        MultiResponseOutrightMarketResponse: {
            success: boolean;
            errCode: string;
            errMessage: string;
            data: components["schemas"]["OutrightMarketResponse"][];
        };
        /**
         * 冠军盘盘口赔率
         * @description outright列表
         */
        OutrightMarketResponse: {
            /**
             * outrightId
             * @description 冠军盘id
             */
            outrightId: string;
            /**
             * outrightName
             * @description 对应的联赛/杯赛/锦标赛 名称
             */
            outrightName: string;
            /**
             * 盘口列表
             * @description 盘口列表
             */
            marketList: components["schemas"]["MarketResponse"][];
        };
        MultiResponseMarketResponse: {
            success: boolean;
            errCode: string;
            errMessage: string;
            data: components["schemas"]["MarketResponse"][];
        };
        /** 获取默认展示的赔率格式 */
        OddsFormatResponse: {
            /**
             * 赔率格式
             * Format: int32
             * @description 赔率格式
             */
            oddsFormat: number;
        };
        SingleResponseOddsFormatResponse: {
            success: boolean;
            errCode: string;
            errMessage: string;
            data: components["schemas"]["OddsFormatResponse"];
        };
        /** 按玩法类型分组的赔率 */
        MatchMarketResponse: {
            /**
             * tab名称
             * @description tab名称
             */
            tabName: string;
            /**
             * tab类型
             * @description tab类型
             */
            marketTabType: string;
            /**
             * 盘口列表
             * @description 盘口列表
             */
            markets: components["schemas"]["MarketResponse"][];
        };
        MultiResponseMatchMarketResponse: {
            success: boolean;
            errCode: string;
            errMessage: string;
            data: components["schemas"]["MatchMarketResponse"][];
        };
        MultiResponseStrategySportTabI18n: {
            success: boolean;
            errCode: string;
            errMessage: string;
            data: components["schemas"]["StrategySportTabI18n"][];
        };
        StrategySportTabI18n: {
            /** Format: int64 */
            id: number;
            sportId: string;
            tabId: string;
            strategyId: string;
            name: string;
            languageCode: string;
        };
        MultiResponseTopOutrightResponse: {
            success: boolean;
            errCode: string;
            errMessage: string;
            data: components["schemas"]["TopOutrightResponse"][];
        };
        /** top outright返回值 */
        TopOutrightResponse: {
            /**
             * sportId
             * @description 运动id
             */
            sportId: string;
            /**
             * sportName
             * @description 运动name 国际化
             */
            sportName: string;
            /**
             * outrightName
             * @description 运动name 默认名称，前端跳转使用
             */
            name: string;
            /**
             * outright列表
             * @description outright列表
             */
            outrightList: components["schemas"]["OutrightMarketResponse"][];
        };
        SingleResponseOddsSystemOfferedResponse: {
            success: boolean;
            errCode: string;
            errMessage: string;
            data: components["schemas"]["OddsSystemOfferedResponse"];
        };
        /** 获取SystemOffered配置 */
        OddsSystemOfferedResponse: {
            /**
             * 是否展示system bet
             * Format: int32
             * @description 是否展示system bet
             */
            systemOffered: number;
        };
        SingleResponseOddsSettingResponse: {
            success: boolean;
            errCode: string;
            errMessage: string;
            data: components["schemas"]["OddsSettingResponse"];
        };
        OddsSettingResponse: {
            /**
             * 赔率格式
             * Format: int32
             * @description 赔率格式
             */
            oddsFormat: number;
            /**
             * 展示模式
             * @description 展示模式
             */
            marketModes: {
                [key: string]: number[];
            };
        };
    };
    responses: never;
    parameters: never;
    requestBodies: never;
    headers: never;
    pathItems: never;
}
export type $defs = Record<string, never>;
export interface operations {
    commonBatchGetRecommend: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["BatchQueryOddsLeagueRequest"];
            };
        };
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseMapLongListSfOutcomeDetailResult"];
                };
            };
        };
    };
    outrightMarketCount: {
        parameters: {
            query?: {
                outrightIds?: string[];
            };
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseMapStringInteger"];
                };
            };
        };
    };
    getOutcomesForCodes: {
        parameters: {
            query?: never;
            header?: {
                "X-Country"?: string;
                "X-Custom-Language"?: string;
            };
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["OutcomeBatchParam"][];
            };
        };
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["MultiResponseOutcomeDetailResult"];
                };
            };
        };
    };
    getMarketsForMatches: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["MarketBatchParam"];
            };
        };
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["MultiResponseMatchMarketResult"];
                };
            };
        };
    };
    getMarketsForMatchesByTab: {
        parameters: {
            query?: never;
            header?: {
                "X-Country"?: string;
                "X-Custom-Language"?: string;
            };
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["MarketBatchParamByTab"];
            };
        };
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["MultiResponseMatchMarketResult"];
                };
            };
        };
    };
    checkMarketExistence: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["MarketExistenceBatchParam"];
            };
        };
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["MultiResponseMarketExistenceResult"];
                };
            };
        };
    };
    recommendTop: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["MarketRecommendTopRequest"];
            };
        };
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseMatchRecommendTopResponse"];
                };
            };
        };
    };
    recommendBatch: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["MarketRecommendBatchRequest"];
            };
        };
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseMatchRecommendBatchResponse"];
                };
            };
        };
    };
    listSnapshot: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["QueryOddsSnapshotRequest"];
            };
        };
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["MultiResponseOutcomeDetailResult"];
                };
            };
        };
    };
    listSnapshot_1: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["QueryOddsSnapshotRequest"];
            };
        };
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["MultiResponseOutcomeDetailResult"];
                };
            };
        };
    };
    listLatestOutcomes: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["BatchOutcomeLatestParam"][];
            };
        };
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["MultiResponseOutcomeDetailResult"];
                };
            };
        };
    };
    listLatestOutcomes_1: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["BatchOutcomeLatestParam"][];
            };
        };
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["MultiResponseOutcomeDetailResult"];
                };
            };
        };
    };
    listRecommendOdds: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["BatchQueryOddsRequest"];
            };
        };
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseMapLongListSfOutcomeDetailResult"];
                };
            };
        };
    };
    listRecommendOdds_1: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["BatchQueryOddsRequest"];
            };
        };
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseMapLongListSfOutcomeDetailResult"];
                };
            };
        };
    };
    listBookmakerOdds: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["BatchQueryBookmakerOddsRequest"];
            };
        };
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseMapLongListSfMarketOutcomeResponse"];
                };
            };
        };
    };
    listBookmakerOdds_1: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["BatchQueryBookmakerOddsRequest"];
            };
        };
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseMapLongListSfMarketOutcomeResponse"];
                };
            };
        };
    };
    listOddsHistoryBatch: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["BatchQueryOddsHistoryRequest"];
            };
        };
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["MultiResponseBatchOddsHistoryResponse"];
                };
            };
        };
    };
    listOddsHistoryBatch_1: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["BatchQueryOddsHistoryRequest"];
            };
        };
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["MultiResponseBatchOddsHistoryResponse"];
                };
            };
        };
    };
    cbCalculate: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["CBCalculateRequest"];
            };
        };
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseCBCalculateResponse"];
                };
            };
        };
    };
    cbCalculateFilter: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["CBCalculateRequest"];
            };
        };
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseCBCalculateFilterResponse"];
                };
            };
        };
    };
    setstesf22: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponse"];
                };
            };
        };
    };
    outrightMarketDetail: {
        parameters: {
            query: {
                /** @description outrightIds */
                outrightIds: string[];
            };
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["MultiResponseOutrightMarketResponse"];
                };
            };
        };
    };
    listBenchmarkOtherBalance: {
        parameters: {
            query: {
                /** @description 比赛id */
                matchId: string;
                /** @description 运动类型 */
                sportId: string;
                /** @description 赛前/滚球，0-赛前盘1-滚球盘 */
                phase: number;
            };
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["MultiResponseMarketResponse"];
                };
            };
        };
    };
    getOddsFormat: {
        parameters: {
            query?: never;
            header?: {
                "X-Country"?: string;
            };
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseOddsFormatResponse"];
                };
            };
        };
    };
    listCustomBetMarkets: {
        parameters: {
            query: {
                /** @description 比赛id */
                matchId: string;
                /** @description 运动类型 */
                sportId: string;
            };
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["MultiResponseMatchMarketResponse"];
                };
            };
        };
    };
    listBenchmarkAll: {
        parameters: {
            query: {
                /** @description 比赛id */
                matchId: string;
                /** @description 运动类型 */
                sportId: string;
            };
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["MultiResponseMatchMarketResponse"];
                };
            };
        };
    };
    testfunc: {
        parameters: {
            query: {
                siteMatchId: string;
                bookmakerId: number;
                phase: number;
            };
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": string;
                };
            };
        };
    };
    testfunc2: {
        parameters: {
            query: {
                siteMatchId: string;
                marketId: string;
                specifiers: string;
            };
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": string;
                };
            };
        };
    };
    outcomeDefToTitleCase: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
        };
    };
    createBzRecommendBatch1: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["MarketRecommendBatchRequest"];
            };
        };
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseMatchRecommendBatchResponse"];
                };
            };
        };
    };
    getBzOutrightTop: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["MultiResponseTopOutrightResponse"];
                };
            };
        };
    };
    getOddsBzOffered: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseOddsSystemOfferedResponse"];
                };
            };
        };
    };
    getOddsBzSetting: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseOddsSettingResponse"];
                };
            };
        };
    };
}
export enum ApiPaths {
    commonBatchGetRecommend = "/openfeign/odds/v2/recommend",
    outrightMarketCount = "/openfeign/odds/v2/outrightMarketCount",
    getOutcomesForCodes = "/openfeign/odds/v2/getOutcomesForCodes",
    getMarketsForMatches = "/openfeign/odds/v2/getMarketsForMatches",
    getMarketsForMatchesByTab = "/openfeign/odds/v2/getMarketsForMatchesByTab",
    checkMarketExistence = "/openfeign/odds/v2/checkMarketExistence",
    recommendTop = "/openfeign/odds/v2/bz/recommend/top",
    recommendBatch = "/openfeign/odds/v2/bz/recommend/batch",
    listSnapshot = "/openapi/odds/v2/snapshot",
    listSnapshot_1 = "/api/odds/v2/snapshot",
    listLatestOutcomes = "/api/odds/v2/listLatestOutcomes",
    listLatestOutcomes_1 = "/openapi/odds/v2/listLatestOutcomes",
    listRecommendOdds = "/api/odds/v2/list/recommend",
    listRecommendOdds_1 = "/openapi/odds/v2/list/recommend",
    listBookmakerOdds = "/openapi/odds/v2/list/bookmaker",
    listBookmakerOdds_1 = "/api/odds/v2/list/bookmaker",
    listOddsHistoryBatch = "/openapi/odds/v2/batchHistoryByMarketCode",
    listOddsHistoryBatch_1 = "/api/odds/v2/batchHistoryByMarketCode",
    cbCalculate = "/api/odds/v2/bz/custombet/calculate",
    cbCalculateFilter = "/api/odds/v2/bz/custombet/calculateFilter",
    setstesf22 = "/api/odds/v2/bz/test",
    outrightMarketDetail = "/api/odds/v2/bz/outright/detail",
    listBenchmarkOtherBalance = "/api/odds/v2/bz/other/balance",
    getOddsFormat = "/api/odds/v2/bz/format",
    listCustomBetMarkets = "/api/odds/v2/bz/custombet",
    listBenchmarkAll = "/api/odds/v2/bz/all",
    testfunc = "/api/odds/testfunc",
    testfunc2 = "/api/odds/testfunc2",
    outcomeDefToTitleCase = "/api/odds/outcomeDefToTitleCase",
    createBzRecommendBatch1 = "/api/odds/v2/bz/recommend/batch",
    getBzOutrightTop = "/api/odds/v2/bz/outright/top",
    getOddsBzOffered = "/api/odds/v2/bz/system/offered",
    getOddsBzSetting = "/api/odds/v2/bz/setting"
}
